module.exports = __webpack_public_path__ + "img/pay2.7ff300c9.png";